//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import businessDomainService from '@/apps/data-platform/services/master_data/business_domain_service';
import businessSubdomainService from '@/apps/data-platform/services/master_data/business_subdomain_service';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import tasks from '@/js/tasks';
export default {
  name: 'TabBusinessTermView',
  props: {
    item: {
      type: Object,
      default: null
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      leyenda: '*This tab is independent of the workflow. You can record the business term without having to be approved, as long as you have the role assigned for it.',
      fields: [{
        key: 'name',
        label: 'Column',
        class: 'w-25'
      }, {
        key: 'field_name',
        label: 'Original column',
        class: 'w-25'
      }, {
        key: 'business_definition',
        label: 'Business Definition',
        class: 'w-10'
      }, {
        key: 'business_term',
        label: 'Business Term',
        class: 'w-10'
      }, {
        key: 'navigator',
        label: '',
        class: 'w-5 text-center'
      }],
      selectBusinessDomain: [],
      selectbusinessSubdomain: [],
      selectbusinessTerm: [],
      kdomain: '',
      ksubdomain: '',
      kbusiness_term: '',
      input1Return: ''
    };
  },
  computed: {
    filterSubdomain: function filterSubdomain() {
      var _this = this;
      var selectbusinessSubdomain = this.selectbusinessSubdomain.filter(function (Subdomain) {
        return Subdomain.kdomain.includes(_this.kdomain);
      });
      return selectbusinessSubdomain;
    },
    filterBusinessterm: function filterBusinessterm() {
      var _this2 = this;
      var selectbusinessTerm = this.selectbusinessTerm.filter(function (bterm) {
        return bterm.status === true && bterm.ksubdomain.includes(_this2.ksubdomain);
      });
      return selectbusinessTerm;
    },
    columnas: function columnas() {
      return this.item === null ? null : this.item.columns;
    }
  },
  created: function created() {
    this.userInfo = tasks.getUserInfo();
    this.getBusinessDomainQuery();
    this.getBusinessSubdomainQuery();
    this.getBusinessTermQuery();
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this3 = this;
      var datasource = {
        domain: window.userInfo.domain,
        datasource: this.item
      };
      TableauDatasourceService.tableauDataSourceAddUpdate(datasource).then(function (res) {
        if (res.success && res.code === 200) {
          if (res.success) {
            tasks.toast.success('Successfully saved');
            //alert('Successfully saved')
            _this3.onCancel();
          } else {
            tasks.toast.error(res.message);
            //alert(res.message)
            _this3.onCancel();
          }
        }
      }).then(function () {
        _this3.$emit('onSave', datasource.datasource);
      });
    },
    onCloseBusinessTerm: function onCloseBusinessTerm(index) {
      var popover = 'popover-reactive-';
      var popover2 = popover.concat(index);
      this.$refs[popover2].doClose();
    },
    onOkBusinessTerm: function onOkBusinessTerm(index) {
      if (this.input1Return) {
        this.onCloseBusinessTerm(index);
        this.item.columns[index].business_term = this.input1Return;
        this.input1Return = '';
        this.kdomain = '';
        this.ksubdomain = '';
      }
    },
    searchBusinessterm: function searchBusinessterm(kbterm) {
      var obj = this.selectbusinessTerm.filter(function (bterm) {
        return bterm.kbusiness_term === kbterm;
      });
      if (obj.length > 0) {
        return obj[0].business_term;
      } else {
        return '';
      }
    },
    onCloseDeleteBusinesTerm: function onCloseDeleteBusinesTerm(index) {
      var popover = 'popover-reacDel-';
      var popover2 = popover.concat(index);
      this.$refs[popover2].doClose();
    },
    onOkDeleteBusinessTerm: function onOkDeleteBusinessTerm(index) {
      this.onCloseDeleteBusinesTerm(index);
      this.item.columns[index].business_term = '';
    },
    onCancel: function onCancel() {
      this.$emit('onCancel', null);
    },
    getBusinessDomainQuery: function getBusinessDomainQuery() {
      var _this4 = this;
      this.cDomain = this.userInfo.domain;
      var businessDomain = {
        domain: this.cDomain
      };
      businessDomainService.getBusinessDomains(businessDomain).then(function (response) {
        for (var i = 0; i < response.data.result.length; i++) {
          _this4.selectBusinessDomain.push({
            value: response.data.result[i].kdomain,
            text: response.data.result[i].domain
          });
        }
      });
    },
    getBusinessSubdomainQuery: function getBusinessSubdomainQuery() {
      var _this5 = this;
      this.cDomain = this.userInfo.domain;
      var businessDomain = {
        domain: this.cDomain,
        page: 1,
        limit: 100,
        clauses: {}
      };
      businessSubdomainService.getBusinessSubdomains(businessDomain).then(function (iResponse) {
        for (var i = 0; i < iResponse.data.result.length; i++) {
          _this5.selectbusinessSubdomain.push({
            kdomain: iResponse.data.result[i].kdomain,
            value: iResponse.data.result[i].ksubdomain,
            text: iResponse.data.result[i].subdomain
          });
        }
      });
    },
    getBusinessTermQuery: function getBusinessTermQuery() {
      var _this6 = this;
      this.cDomain = this.userInfo.domain;
      var businessDomain = {
        domain: this.cDomain,
        clauses: {}
      };
      businessTermService.getBusinessTerms(businessDomain).then(function (iResponse2) {
        for (var i = 0; i < iResponse2.data.result.length; i++) {
          _this6.selectbusinessTerm.push({
            value: iResponse2.data.result[i].kbusiness_term,
            text: iResponse2.data.result[i].business_term,
            kdomain: iResponse2.data.result[i].kdomain,
            ksubdomain: iResponse2.data.result[i].ksubdomain,
            kbusiness_term: iResponse2.data.result[i].kbusiness_term,
            business_term: iResponse2.data.result[i].business_term,
            status: iResponse2.data.result[i].status
          });
        }
      });
    }
  }
};